import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold text-blue-600">Bông iu shop</span>
          </Link>

          {/* Menu Desktop */}
          <nav className="hidden md:flex items-center gap-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition">Trang chủ</Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium transition">Giới thiệu</Link>
            <Link to="/products" className="text-gray-700 hover:text-blue-600 font-medium transition">Sản phẩm</Link>
            {/* <Link to="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition">Liên hệ</Link> */}
          </nav>

          {/* Buttons Desktop */}
          {/* <div className="hidden md:flex items-center gap-x-3">
            <Link 
              to="/login"
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 transition"
            >
              Đăng nhập
            </Link>
            <Link 
              to="/register"
              className="px-5 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Đăng ký
            </Link>
          </div> */}

          {/* Hamburger Button (Mobile) */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 focus:outline-none"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6h12v12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t py-4 bg-white">
            <nav className="flex flex-col gap-y-4 px-4">
              <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-gray-700 font-medium">Trang chủ</Link>
              <Link to="/about" onClick={() => setIsMenuOpen(false)} className="text-gray-700 font-medium">Giới thiệu</Link>
              <Link to="/products" onClick={() => setIsMenuOpen(false)} className="text-gray-700 font-medium">Sản phẩm</Link>
              {/* <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="text-gray-700 font-medium">Liên hệ</Link> */}
              
              {/* <div className="flex flex-col gap-y-3 pt-4 border-t">
                <Link to="/login" onClick={() => setIsMenuOpen(false)} className="text-center py-2 text-gray-700 font-medium">Đăng nhập</Link>
                <Link to="/register" onClick={() => setIsMenuOpen(false)} className="text-center py-2 bg-blue-600 text-white rounded-lg font-medium">Đăng ký</Link>
              </div> */}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}